module.exports = __webpack_public_path__ + "img/inventar-active.23497d79.svg";